export const DropsProductSummaryMolecule = () => {
  return (
    <div data-cy="drops-product-summary" className="w-full">
      <div className="flex items-center w-full">
        <div className="w-32 pr-5">
          <img src="/images/drop-quick.png" className="w-20 mx-auto " />
        </div>
        <div className="flex flex-col pl-1 flex-1">
          <h3 className="text-base font-waldo-sans font-semibold md:text-lg">
            Hydration Drops
          </h3>
          <div className="flex justify-between">
            <p className="text-base font-waldo-sans mt-2 text-left md:text-lg">
              1 bottle
            </p>
            <p className="text-base font-waldo-sans mt-2 text-right md:text-lg">
              $10 per bottle
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
